import * as React from 'react';
import * as PropTypes from 'prop-types';

import {
  HeaderWrapper,
  HeaderTitle,
  Title,
  RenderComponent,
  HeaderSubTitle
} from './styled'

interface Props {
  posComponent?: string;
  title: string;
  renderComponent?: Function;
  subTitle?: string;
}

export const Header: React.FC<Props> = ({
  title,
  renderComponent,
  posComponent,
  subTitle
}) => {

  return (
    <HeaderWrapper>
      <HeaderTitle posComponent={posComponent || 'end'}>
        <Title data-test="userPageTitle">{title}</Title>
        {renderComponent && (
          <RenderComponent>{renderComponent()}</RenderComponent>
        )}
      </HeaderTitle>
      {subTitle && (<HeaderSubTitle data-test="userPageSubTitle">{subTitle}</HeaderSubTitle>)}
    </HeaderWrapper>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  posComponent: PropTypes.string,
  renderComponent: PropTypes.func,
  subTitle: PropTypes.string
}
